const storeSetting = {
    sizeList: () => 'admin/size-list',
    addSize: () => `admin/size`,
    UpdateSize: (id:string) => `admin/size/${id}`,
    deleteSize: (id:string) => `admin/size/${id}`

}
export default storeSetting